module.exports = __webpack_public_path__ + "img/pvc_600g_farbauswahl_schwarz_grau_gruen.a3f2cb15.jpg";